import { render, staticRenderFns } from "./videoCallModal.vue?vue&type=template&id=ce70e168&scoped=true"
import script from "./videoCallModal.vue?vue&type=script&lang=js"
export * from "./videoCallModal.vue?vue&type=script&lang=js"
import style0 from "./videoCallModal.vue?vue&type=style&index=0&id=ce70e168&prod&lang=scss&scoped=true"
import style1 from "./videoCallModal.vue?vue&type=style&index=1&id=ce70e168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce70e168",
  null
  
)

export default component.exports